import type { EligibilityRule } from './admin-api';

/** v7 account-card stat formatting: 1234 → "1.2k". */
export function formatStat(n: number): string {
  return n > 999 ? `${(n / 1000).toFixed(1)}k` : String(n);
}

/** v7 "Last Batch" date format: "Apr 22, 2026" (— when unknown). */
export function formatBatch(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  // UTC: batch dates are calendar dates — local-tz rendering would shift
  // midnight-UTC stamps to the previous day for US viewers.
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/** Eligibility-builder field catalog (used by the Products step). */
export const RULE_FIELDS = [
  { value: 'account_balance', label: 'Account balance' },
  { value: 'account_age', label: 'Account age (months)' },
  { value: 'product_count', label: 'Product count' },
  { value: 'account_type', label: 'Account type' },
  { value: 'smb_growth', label: 'SMB growth flag' },
  { value: 'is_homeowner', label: 'Homeowner' },
] as const;

export const RULE_OPERATORS = [
  'greater than',
  'less than',
  'is',
  'is true',
  'Is homeowner',
] as const;

export function newRule(): EligibilityRule {
  return { field: 'account_balance', operator: 'greater than', value: '', required: false };
}

/** Friendly label for an eligibility-rule field value (falls back to the raw value). */
export function ruleFieldLabel(field: string): string {
  return RULE_FIELDS.find((f) => f.value === field)?.label ?? field;
}
